import { render, staticRenderFns } from "./BandejaEmbajadorSeguimiento.vue?vue&type=template&id=976a6782&scoped=true"
import script from "./BandejaEmbajadorSeguimiento.vue?vue&type=script&lang=js"
export * from "./BandejaEmbajadorSeguimiento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "976a6782",
  null
  
)

export default component.exports